import { parsePhoneNumberFromString } from "libphonenumber-js";
import DateUtil from "@/utils/DateUtil";

export const valid = error => {
  return {
    is_error: error != null && error.length > 0,
    message: error,
  };
};

/**
 * 電話番号のフォーマットが正しいか検証する
 * @param phoneNumber 電話番号
 */
const validateTel_jp = phoneNumber => {
  if (phoneNumber) {
    const parsedPhoneNumber = parsePhoneNumberFromString(
      "+81" + phoneNumber,
      "JA"
    );
    return parsedPhoneNumber ? parsedPhoneNumber.isValid() : false;
  } else {
    return false;
  }
};

/**
 * 入力された日付が未来日か検証する
 * @param targetDate 比較対象日付
 */
const isFutureDate = targetDate => {
  if (targetDate) {
    let today = new Date();
    let granularity = "day";
    return DateUtil.isBefore(today, targetDate, granularity);
  } else {
    return false;
  }
};

/**
 * 入力された文字列が全て数字か検証する
 * @param str 対象文字列
 */
const isAllDigits = str => {
  return /^\d+(\.\d+)?$/.test(str);
};

/**
 * 入力された文字列が指定した文字数以内か検証する
 * @param str 対象文字列
 */
const isWithinCharacterLimit = (str, limit) => {
  return str.length <= limit;
};

/**
 * 入力された文字列がメールアドレスか検証する
 * @param email 対象文字列
 */
const isValidEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export default {
  validateTel_jp: validateTel_jp,
  isFutureDate: isFutureDate,
  isAllDigits: isAllDigits,
  isWithinCharacterLimit: isWithinCharacterLimit,
  isValidEmail: isValidEmail,
};
